import React from 'react';
import { SHEER_PAGE_TYPES } from 'Utils/SheerIdHelpers';
import './RestartVerificationButton.css';

const RestartVerificationButton = ({ setPage }) => {
  // TODO Add check to if military or first responder
  const onClick = () => setPage(SHEER_PAGE_TYPES.MILITARY_FORM);
  return (
    <button onClick={onClick} className="restartSubscriptionButton">
      <img src="/account/static/images/arrow-restart.svg" className="restartSubscriptionIcon" alt="restart-arrow" />
      Restart Verification
    </button>
  );
};

export default RestartVerificationButton;
